import { useMutation, useQuery, useQueryClient } from "react-query";
import { http } from "src/api/http";
import { Campaign, CampaignMessage } from "./models";
import { API_ROUTE } from "./constant";

export function useCampaignListAPI() {
  return useQuery<Campaign[]>({
    queryKey: ["useCampaigns"],
    queryFn: () => http(API_ROUTE)
  });
}

export function useCampaignSendAPI(successCallback?: () => void) {
  return useMutation({
    mutationFn: (id: string) => http(`/api/my-fans/send/${id}`, {
      method: 'POST',
    }),
    onSuccess: successCallback
  });
}

export function useCampaignUpdateAPI(successCallback?: (campaign: Campaign) => void) {
  return useMutation({
    mutationFn: (body: Campaign) => http(API_ROUTE, {
      method: 'POST',
      body,
    }),
    onSuccess: (response: Campaign) => successCallback?.(response)
  });
}

export function useCampaignDetailsAPI(id: string | undefined, settledCallback?: () => void) {
  return useQuery<Campaign>({
    queryKey: ["useCampaignDetails", id],
    queryFn: () => http(`${API_ROUTE}/${id}`),
    enabled: id !== "new",
    onSettled: settledCallback
  });
}

export function useCampaignMessagesAPI(id: string | undefined, settledCallback?: () => void) {
  return useQuery<CampaignMessage[]>({
    queryKey: ["useCampaignMessages", id],
    queryFn: () => http(`/api/my-fans/messages/${id}`),
    enabled: !!id && id !== "new",
    onSettled: settledCallback
  });
}
